/*
 * zero-price-guard.js
 * Evita que productos "a consultar" (precio $0) se puedan agregar al carrito
 * desde las cards de producto del theme (recomendados, sliders, grillas).
 *
 * Por qué: la card del theme (snippet product-card.liquid) renderiza el boton
 * directo "Agregar al carrito" (.product-card--add-to-cart-button-simple) cuando
 * el producto esta disponible y tiene 1 variante, SIN contemplar precio 0. Eso
 * permitia agregar al carrito un chasis/producto a consultar por $0 (bug grave).
 *
 * Que hace: detecta cards cuyo precio visible es exactamente $0 y reemplaza el
 * boton de compra directa por un link "Consultar" que lleva a la ficha (donde el
 * bloque de precio ya muestra el CTA de WhatsApp). Ademas bloquea el click por las
 * dudas (race) y observa el DOM para cards que cargan async (recomendados/Globo).
 *
 * Nota: la grilla de Globo (snippet globo.filter.product.liquid) ya maneja el $0
 * por su cuenta; este guard cubre las cards nativas del theme.
 */
(function () {
  'use strict';

  var BTN_SEL = '.product-card--add-to-cart-button-simple';

  function digits(str) {
    return (str || '').replace(/[^\d]/g, '');
  }

  // El precio principal de la card. Se ignoran compare/old (precio tachado) para
  // no confundir un "$0" tachado con el precio real.
  function cardPriceIsZero(card) {
    var price = card.querySelector('.price');
    if (!price) return false;
    var clone = price.cloneNode(true);
    clone.querySelectorAll('[class*="compare"],[class*="old"],s,del').forEach(function (el) {
      el.remove();
    });
    // Solo tratamos como "$0" cuando hay un 0 explicito (no string vacio, para
    // evitar falsos positivos mientras el precio aun no renderizo).
    return digits(clone.textContent) === '0';
  }

  // El <product-card> (o item de grilla) que contiene el boton. Importante: NO
  // usar [class*="product-card"] porque la clase del propio boton lo contiene.
  function findCard(el) {
    return el.closest('product-card, .grid__item, .spf-product-card-wrapper, li, article');
  }

  function productUrl(card) {
    var link = card.querySelector('a.product-card-image-link, a[href*="/products/"]');
    return link ? link.getAttribute('href').split('?')[0] : null;
  }

  function neutralize(root) {
    var scope = root || document;
    var buttons = Array.from(scope.querySelectorAll(BTN_SEL + ':not([data-zero-guard-checked])'));
    if (scope.matches && scope.matches(BTN_SEL + ':not([data-zero-guard-checked])')) {
      buttons.unshift(scope);
    }
    buttons.forEach(function (btn) {
      btn.setAttribute('data-zero-guard-checked', '1');
      var card = findCard(btn);
      if (!card || !cardPriceIsZero(card)) return;

      btn.setAttribute('data-zero-guard', '1');
      var url = productUrl(card) || (card.querySelector('a[href]') && card.querySelector('a[href]').getAttribute('href')) || '#';

      var link = document.createElement('a');
      link.href = url;
      link.className = btn.className.replace('product-card--add-to-cart-button-simple', '').trim() + ' product-card--consultar';
      link.setAttribute('data-zero-guard', '1');
      link.innerHTML = '<span class="product-card--add-to-cart-text">Inquire</span>';
      btn.parentNode.replaceChild(link, btn);
    });
  }

  // Guard duro: si por un race alguien clickea el boton de $0 antes de que se
  // reemplace, lo frenamos y lo mandamos a la ficha.
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest(BTN_SEL);
      if (!btn) return;
      var card = findCard(btn);
      if (card && cardPriceIsZero(card)) {
        e.preventDefault();
        e.stopPropagation();
        var url = productUrl(card);
        if (url) window.location.href = url;
      }
    },
    true
  );

  function run() {
    try {
      neutralize(document);
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Cards que cargan async (recomendados, Globo, paginacion): se inspeccionan
  // solamente los nodos agregados, sin re-escanear toda la pagina.
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) neutralize(node);
      });
    });
  });
  if (document.body) observer.observe(document.body, { subtree: true, childList: true });

  // Editor de Shopify: recarga secciones sin recargar la pagina.
  document.addEventListener('shopify:section:load', function (e) {
    neutralize(e.target);
  });
})();
